<app-main-notice/>

<div class="bg-accent" ngClass.gt-xs="c-black">
  <!--서비스 소개 시작-->
  <div [class.mobile-login-hero-hidden]="isLogin"
       [ngClass.gt-xs]="isLogin ? 'bg-gr-main-header m-t-m110' : 'bg-white m-t-m110'">
    <h1 class="main-page-title">부동산 권리분석과 등기변경 알림 서비스, 체크팀</h1>
    <section class="main-visual-section min-h-1 p-0">
      <div [ngClass.gt-xs]="isLogin ? 'p-t-170 p-b-160 bg-gr-main-header' : 'p-t-170 p-b-170'">

        @if (isLogin) {
          <div>
            <app-swiper [autoplay]="false" [navigation]="true" [hideNavigationOnMobile]="true" [showStatus]="true"
                        class="main-hero-swiper" paginationType="bullets" swiperId="loginSwiper">

              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        부동산 권리분석
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        부동산 <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">권리분석, </span>
                        <div fxHide.gt-xs fxShow></div>
                        어렵고 걱정되시죠?
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        체크팀으로 <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">내일의 위험까지 분석</span>하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3" routerLink="/analysis/info">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          <!-- 신규 가입 권리분석 무료 쿠폰 종료에 따라 무료 이용을 약속하지 않습니다. -->
                          권리분석 하기
                        </div>
                      </a>
                    </div>

                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="체크팀 권리분석" class="w-100"
                             src="assets/img/service/alpha-data-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="체크팀 권리분석" class="w-37 p-r-10"
                             src="assets/img/service/alpha-data-accent.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        부동산 등기변경 알림
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        한 번의 신청으로,
                        <div fxHide.gt-xs fxShow></div>
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">변경 정보</span>를 빠르게 확인!
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">위험 등기변경 정보</span>를 간편하게 확인하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3"
                         routerLink="/house/register">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          부동산 알림 신청
                        </div>
                      </a>
                    </div>

                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="등기변경알림" class="w-100"
                             src="assets/img/service/alpha-messagecheck-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="등기변경알림" class="w-37 p-r-10"
                             src="assets/img/service/alpha-messagecheck-accent.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        부동산 시세 검색
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">오늘의 시세</span>부터,
                        <div fxHide.gt-xs fxShow></div>
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">2년 뒤 가격</span> 흐름까지!
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">실거래가와 AI 예측 시세</span>를 한 번에 확인하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3" routerLink="/scorer">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          주소 입력하고 시세 확인
                        </div>
                      </a>
                    </div>

                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="부동산 시세 검색" class="w-100"
                             src="assets/img/service/alpha-graph-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="부동산 시세 검색" class="w-37 p-r-10"
                             src="assets/img/service/alpha-graph-accent.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>


              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        오픈부동산
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">사업자와 투자자, </span>
                        <div fxHide.gt-xs fxShow></div>
                        등기변경 자동 확인!
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">담보현황과 변경등기</span>를 빠르게 확인하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3" routerLink="/house/open">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          투자 부동산 알림 신청
                        </div>
                      </a>

                    </div>
                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="등기변경알림" class="w-100"
                             src="assets/img/service/alpha-alarm-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="등기변경알림" class="w-37 p-r-10"
                             src="assets/img/service/alpha-alarm-accent.svg"/>
                      </div>
                    </div>

                  </div>
                </div>
              </swiper-slide>
            </app-swiper>
          </div>
        } @else {
          <div ngClass.xs="p-h-3">
            <app-swiper [autoplay]="false" [navigation]="true" [hideNavigationOnMobile]="true" [showStatus]="true"
                        class="main-hero-swiper" paginationType="bullets" swiperId="logoutSwiper">

              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        부동산 권리분석
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        부동산 <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">권리분석, </span>
                        <div fxHide.gt-xs fxShow></div>
                        어렵고 걱정되시죠?
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        체크팀으로 <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">내일의 위험까지 분석</span>하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3" routerLink="/analysis/info">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          <!-- 신규 가입 권리분석 무료 쿠폰 종료에 따라 무료 이용을 약속하지 않습니다. -->
                          권리분석 하기
                        </div>
                      </a>
                    </div>

                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="체크팀 권리분석" class="w-100"
                             src="assets/img/service/alpha-data-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="체크팀 권리분석" class="w-37 p-r-10"
                             src="assets/img/service/alpha-data-accent.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        부동산 등기변경 알림
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        한 번의 신청으로,
                        <div fxHide.gt-xs fxShow></div>
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">변경 정보</span>를 빠르게 확인!
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">위험 등기변경 정보</span>를 간편하게 확인하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3"
                         routerLink="/house/register">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          부동산 알림 신청
                        </div>
                      </a>
                    </div>

                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="등기변경알림" class="w-100"
                             src="assets/img/service/alpha-messagecheck-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="등기변경알림" class="w-37 p-r-10"
                             src="assets/img/service/alpha-messagecheck-accent.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>


              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        부동산 시세 검색
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">오늘의 시세</span>부터,
                        <div fxHide.gt-xs fxShow></div>
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">2년 뒤 가격</span> 흐름까지!
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">실거래가와 AI 예측 시세</span>를 한 번에 확인하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3" routerLink="/scorer">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          내 부동산 시세 확인
                        </div>
                      </a>
                    </div>

                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="부동산 시세 검색" class="w-100"
                             src="assets/img/service/alpha-graph-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="부동산 시세 검색" class="w-37 p-r-10"
                             src="assets/img/service/alpha-graph-accent.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div ngClass="narrow-section min-h-10 p-0" ngClass.xs="p-h-25 p-b-30 p-t-20">
                  <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
                    <div fxFlex.gt-xs="80" ngClass.gt-xs="p-l-10">
                      <div ngClass.gt-xs="text-16 p-b-8 p-l-5 c-accent"
                           ngClass.xs="main-hero-eyebrow text-14 f-w-700 c-accent">
                        오픈부동산
                      </div>
                      <div ngClass.gt-xs="text-45 f-w-300 p-b-20"
                           ngClass.xs="main-hero-title f-22 f-w-400 lh-1-4 p-v-5">
                        <span ngClass.gt-xs="f-w-700" ngClass.xs="f-w-800">사업자와 투자자, </span>
                        <div fxHide.gt-xs fxShow></div>
                        등기변경 자동 확인!
                      </div>
                      <div ngClass.gt-xs="text-22 f-w-400 p-b-10 p-l-5"
                           ngClass.xs="main-hero-description text-16 f-w-400 p-t-5 p-b-5 p-l-2">
                        <span ngClass.xs="f-w-800" ngClass.gt-xs="f-w-700">담보현황과 변경등기</span>를 빠르게 확인하세요.
                      </div>
                      <a class="main-hero-cta" ngClass.gt-xs="p-l-7 m-b-10" ngClass.xs="p-l-3" routerLink="/house/open">
                        <div ngClass.gt-xs="text-13 cursor" ngClass.xs="main-hero-link f-11 f-w-700">
                          투자 부동산 알림 신청
                        </div>
                      </a>

                    </div>
                    <div fxFlex.gt-xs="20">
                      <div fxShow.gt-xs fxHide>
                        <img alt="등기변경알림" class="w-100"
                             src="assets/img/service/alpha-alarm-accent.svg"/>
                      </div>
                      <div fxShow fxHide.gt-xs fxLayoutAlign.xs="end end">
                        <img alt="등기변경알림" class="w-37 p-r-10"
                             src="assets/img/service/alpha-alarm-accent.svg"/>
                      </div>
                    </div>

                  </div>
                </div>
              </swiper-slide>
            </app-swiper>
          </div>

        }
      </div>
    </section>
  </div>
  <!--서비스 소개 끝-->

  @if (!isLogin) {
    <div ngClass.xs="bg-white">
      <section class="min-h-10">
        <div>
          <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center" fxLayout.xs="column"
               ngClass.gt-xs="bg-gray-light p-t-35 p-b-30  p-r-60 p-l-50 brd-150 m-t-m120" ngClass.xs="p-t-10">
            <div fxFlex fxFlex.gt-xs="40" fxHide fxShow.gt-xs>
              <app-swiper class="main-event-swiper" [autoplay]="false" paginationType="bullets">
                <swiper-slide>
                  <a [queryParams]="{id: '82'}" class="main-event-link p-20" routerLink="/info/events/detail">
                    <div fxLayout="row" fxLayoutAlign="center center">
                      <div fxFlex="25">
                        <img alt="신규회원 등기변경알림 30일 무료 쿠폰" class="w-90"
                             src="assets/img/event/coupon-circle-amber.svg">
                      </div>
                      <div fxFlex="75">
                        <div class="f-18 f-w-750 p-b-6">신규회원 등기변경 무료</div>
                        <div class="f-13 f-w-600">등기변경 알림을 30일간 무료로 이용해 보세요!</div>
                      </div>
                    </div>
                  </a>
                </swiper-slide>

                <!-- 신규 가입 권리분석 무료 쿠폰 이벤트 종료: 등기변경 알림·추천인·등기변동 할인 이벤트는 유지합니다. -->

                <swiper-slide>
                  <a [queryParams]="{type: 'EVENT'}" class="main-event-link p-20" fragment="referral-event"
                     routerLink="/info/events">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
                      <div fxFlex="30">
                        <img alt="추천인 이벤트 네이버페이 포인트 3,000원 쿠폰" class="w-100"
                             src="assets/img/event/event-naver-pay-3000.png">
                      </div>
                      <div fxFlex="70">
                        <div class="f-18 f-w-750 p-b-6">친구 추천하고 네이버페이 받으세요</div>
                        <div class="f-13 f-w-600">친구가 무료 쿠폰으로 서비스 이용 시 지급</div>
                      </div>
                    </div>
                  </a>
                </swiper-slide>


                <swiper-slide>
                  <a [queryParams]="{id: '166'}" class="main-event-link p-20" routerLink="/info/events/detail">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
                      <div fxFlex="25">
                        <img alt="등기변경 발생 시 권리분석 50% 할인 쿠폰" class="w-90"
                             src="assets/img/event/coupon-circle-accent.svg">
                      </div>
                      <div fxFlex="75">
                        <div class="f-18 f-w-750 p-b-6">권리분석 50% 할인 쿠폰</div>
                        <div class="f-13 f-w-600">변경된 등기가 내 권리에 미치는 영향, 바로 확인해보세요!</div>
                      </div>
                    </div>
                  </a>
                </swiper-slide>

              </app-swiper>
            </div>

            <div class="main-shortcut-menu" fxFlex fxFlexOffset.gt-xs="5" fxFlex.gt-xs="40" fxLayout="column"
                 ngClass.xs="p-h-20"
                 ngClass.gt-xs="p-t-10">
              <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.xs="space-between center"
                   class="main-shortcut-menu-list text-center cursor p-b-10">
                <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                   routerLink="/info/my-house">
                  <div fxHide fxShow.gt-xs class="box-circle-accent-md bg-accent">
                    <lord-icon src="https://cdn.lordicon.com/ahxaipjb.json" trigger="hover"
                               colors="primary:#ffffff" style="width:30px;height:30px"></lord-icon>
                  </div>
                  <div class="text-14 f-w-700 p-t-5">등기변경 알림</div>
                </a>

                <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                   routerLink="/analysis/info">
                  <div fxHide fxShow.gt-xs class="box-circle-accent-md bg-accent">
                    <lord-icon src="https://cdn.lordicon.com/btfbysou.json" trigger="hover"
                               colors="primary:#ffffff" style="width:30px;height:30px"></lord-icon>
                  </div>
                  <div class="text-14 f-w-700 p-t-5">권리분석</div>
                </a>

                <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                   routerLink="/info/scorer">
                  <div fxHide fxShow.gt-xs class="box-circle-accent-md bg-accent">
                    <lord-icon src="https://cdn.lordicon.com/lrzdmsmx.json" trigger="hover"
                               colors="primary:#ffffff" style="width:30px;height:30px"></lord-icon>
                  </div>
                  <div class="text-14 f-w-700 p-t-5">시세검색</div>
                </a>

                <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                   routerLink="/info/open-house">
                  <div fxHide fxShow.gt-xs class="box-circle-accent-md bg-accent">
                    <lord-icon src="https://cdn.lordicon.com/cfkiwvcc.json" trigger="hover"
                               colors="primary:#ffffff" style="width:30px;height:30px"></lord-icon>
                  </div>
                  <div class="text-14 f-w-700 p-t-5">오픈부동산</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>


    <div fxShow fxHide.gt-xs class="main-mobile-event-banner p-h-20 m-t-30 bg-gray-light">

      <app-swiper class="main-event-swiper" [autoplay]="false" paginationType="bullets">
        <swiper-slide>
          <a [queryParams]="{type: 'EVENT'}" class="main-event-link main-referral-event-mobile"
             fragment="referral-event" routerLink="/info/events">
            <div fxLayout="row" fxLayoutAlign="center center">
              <div fxFlex="30">
                <img alt="추천인 이벤트 네이버페이 포인트 3,000원 쿠폰" class="w-100" src="assets/img/event/event-naver-pay-3000.png">
              </div>
              <div fxFlex="70">
                <div class="f-16 f-w-750 p-b-6 p-l-10">친구 추천 네이버페이</div>
                <div class="f-13 f-w-600 p-l-10">친구가 가입 후 무료 쿠폰 이용 시 지급</div>
              </div>
            </div>
          </a>
        </swiper-slide>

        <swiper-slide>
          <a [queryParams]="{id: '82'}" class="main-event-link p-b-35" routerLink="/info/events/detail">
            <div fxLayout="row" fxLayoutAlign="center center">
              <div fxFlex="30">
                <img alt="신규회원 등기변경알림 30일 무료 쿠폰" class="w-100"
                     src="assets/img/event/coupon-circle-amber.svg">
              </div>
              <div fxFlex="70">
                <div class="f-16 f-w-750 p-b-6 p-l-10">신규회원 등기변경 알림 무료</div>
                <div class="f-13 f-w-600 p-l-10">등기변경 알림을 30일간 무료로 이용해 보세요!</div>
              </div>
            </div>
          </a>
        </swiper-slide>

        <!-- 신규 가입 권리분석 무료 쿠폰 이벤트 종료: 등기변경 알림·추천인·등기변동 할인 이벤트는 유지합니다. -->

        <swiper-slide>
          <a [queryParams]="{id: '166'}" class="main-event-link" routerLink="/info/events/detail">
            <div fxLayout="row" fxLayoutAlign="center center">
              <div fxFlex="30">
                <img alt="등기변경 발생 시 권리분석 50% 할인 쿠폰" class="w-100"
                     src="assets/img/event/coupon-circle-accent.svg">
              </div>
              <div fxFlex="70">
                <div class="f-16 f-w-750 p-b-6 p-l-10">권리분석 50% 할인 쿠폰</div>
                <div class="f-13 f-w-600 p-l-10">변경된 등기가 내 권리에 미치는 영향, 바로 확인해보세요!</div>
              </div>
            </div>
          </a>
        </swiper-slide>




      </app-swiper>
    </div>
  }


  <!--퀵 메뉴-->
  <section [class.login-menu-layout]="isLogin" class="main-visual-section min-h-10 p-v-0">
    <section class="wide-full-section min-h-10 p-v-0">
      <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap.gt-xs="12px" ngClass.gt-xs="p-b-50 p-t-20"
           ngClass.xs="p-h-20">
        <div [class.main-secondary-account-wrapper]="!isLogin" fxFlex="100" fxFlex.gt-xs="25">
          <div class="cursor">
            @if (isLogin) {
              <div ngClass.gt-xs="m-t-m110"></div>
            }
            @if (isLogin) {
              <div class="main-service-card main-my-real-estate-card" fxLayout="column" fxLayoutAlign="center center"
                   ngClass.gt-xs="p-h-35 p-t-30 p-b-30 brd-50 text-center hover-primary-light bg-white"
                   ngClass.xs="bg-white p-h-25 p-t-5 p-b-25 text-center brd-16 m-b-20">
                <a aria-label="마이 부동산 지도 보기" class="main-my-real-estate-map" routerLink="/my-real-estate">
                  <app-house-region-map [compact]="true" [items]="mainMapHouses" mode="summary"/>
                </a>

                <div class="main-my-real-estate-summary">
                  <div ngClass.gt-xs="text-13 p-b-3 text-center p-h-5" ngClass.xs="text-14 p-t-6">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                      <a class="main-summary-link f-w-700" routerLink="/house/list">
                        등기 모니터링
                        <span class="p-l-1">{{
                            counts.house | number
                          }}</span>
                      </a>

                      <a class="main-summary-link f-w-700" routerLink="/analysis/list">
                        권리 분석
                        <span class="p-l-1">{{ counts.analysis | number }}</span>
                        @if (counts.analysisPending > 0) {
                          <span class="p-l-5 f-12 count-point">({{ counts.analysisPending | number }})</span>
                        }
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <a class="main-service-card main-secondary-account-card" fxShow.gt-xs fxHide fxLayout="column"
                 ngClass.gt-xs="bg-white p-h-20 p-v-30 brd-50 cursor hover-primary-light text-center"
                 ngClass.xs="bg-white p-h-30 p-v-20 brd-16 m-b-30" routerLink="/my-real-estate">
                <div>
                  <lord-icon
                    src="https://cdn.lordicon.com/bpmglzll.json"
                    trigger="loop"
                    delay="4000"
                    colors="primary:#0b57d0"
                    style="width:60px;height:60px">
                  </lord-icon>
                </div>

                <div>
                  <div ngClass.gt-xs="m-b-5" ngClass.xs="m-b-4">
                    <div ngClass.gt-xs="text-17 f-w-700 p-t-5" ngClass.xs="text-16">
                      마이 부동산
                    </div>
                  </div>

                  <div ngClass.gt-xs="text-13 f-w-500 p-b-3" ngClass.xs="f-w-600">
                    <div>
                      회원가입 무료 이용권 받기
                    </div>
                  </div>
                </div>
              </a>
            }
          </div>
        </div>


        <div class="p-l-5" fxHide.gt-xs fxShow>
          @if (notices.length > 0 || updates.length > 0) {
            <div class="main-mobile-notice-list m-b-20" fxLayout="column" fxLayoutGap="4px">
              @for (notice of notices; track notice.id) {
                <button (click)="moveNoticeDetail(notice)" class="main-notice-link" fxLayout="row"
                        fxLayoutAlign="start center" fxLayoutGap="7px" type="button">
                  <div class="notice-badge-gray bg-accent">공지사항</div>
                  <div class="main-mobile-notice-title" ngClass.xs="f-13 f-w-650">{{ notice.title }}</div>
                </button>
              }

              @for (update of updates; track update.id) {
                <button (click)="moveNoticeDetail(update)" class="main-notice-link" fxLayout="row"
                        fxLayoutAlign="start center" fxLayoutGap="7px" type="button">
                  <div class="notice-badge-gray bg-accent">업데이트</div>
                  <div class="main-mobile-notice-title" ngClass.xs="f-13 f-w-650">{{ update.title }}</div>
                </button>
              }
            </div>
          }
        </div>


        <div fxFlex="100" fxFlex.gt-xs="25" fxHide fxShow.gt-xs>
          @if (isLogin) {
            <div ngClass.gt-xs="m-t-m110"></div>
          }
          <a [queryParams]="{ type: 'MY_HOUSE' }"
             class="main-service-card bg-gray-light p-v-30 brd-50 cursor text-center"
             fxLayout="column" routerLink="/house/register">
            <div>
              <lord-icon
                colors="primary:#ffffff,secondary:#0b57d0,tertiary:#ffd244"
                src="https://cdn.lordicon.com/qbzakszx.json"
                style="width:60px;height:60px"
                trigger="hover">
              </lord-icon>
            </div>
            <div>
              <div class="m-b-5">
                <div class="text-17 f-w-700 p-t-5">
                  등기변경 알림 신청
                </div>
              </div>
              <div class="f-w-500 p-b-3">
                등기 알림 &middot; 등본 열람
              </div>
            </div>
          </a>
        </div>

        <div fxFlex="100" fxFlex.gt-xs="25" fxHide fxShow.gt-xs>
          @if (isLogin) {
            <div ngClass.gt-xs="m-t-m110"></div>
          }
          <a class="main-service-card bg-gray-light p-v-30 brd-50 cursor text-center" fxLayout="column"
             routerLink="/analysis">
            <div>
              <lord-icon
                colors="primary:#78adff,secondary:#0b57d0,tertiary:#BBD6FF"
                src="https://cdn.lordicon.com/qkcczdgu.json"
                style="width:60px;height:60px"
                trigger="hover">
              </lord-icon>

            </div>
            <div>
              <div class="m-b-5">
                <div class="text-17 f-w-700 p-t-5">
                  권리분석 시작
                </div>
              </div>
              <div class="f-w-500 p-b-3">
                맞춤 권리분석 &middot; 등본 &middot; 시세
              </div>
            </div>
          </a>
        </div>

        <div fxFlex="100" fxFlex.gt-xs="25" fxHide fxShow.gt-xs>
          @if (isLogin) {
            <div ngClass.gt-xs="m-t-m110"></div>
          }
          <a class="main-service-card" fxLayout="column" ngClass.gt-xs="bg-gray-light p-v-30 brd-50 cursor text-center"
             ngClass.xs="bg-white p-h-30 p-v-20 brd-16 m-b-30" routerLink="/scorer">
            <div>
              <lord-icon
                colors="primary:#bbd6ff,secondary:#0b57d0,tertiary:#78adff,quaternary:#ffffff"
                src="https://cdn.lordicon.com/xowcggal.json"
                state="hover-pinch"
                trigger="hover"
                style="width:60px;height:60px"
              ></lord-icon>

            </div>
            <div>
              <div class="m-b-5">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
                  <div ngClass.gt-xs="text-17 f-w-700 p-t-5" ngClass.xs="text-16">
                    AI 부동산 예측시세 검색
                  </div>
                </div>

              </div>

              <div ngClass.gt-xs="f-w-500 p-b-3" ngClass.xs="f-w-600">
                실거래가 &middot; AI 예측 &middot; 시세 비교 분석
              </div>
            </div>
          </a>
        </div>

        <!--모바일 메뉴 UI-->
        <div class="p-b-10" fxHide.gt-xs fxShow>
          <div fxLayout="row" fxLayoutGap="10px">
            <a [queryParams]="{ type: 'MY_HOUSE' }"
               class="main-mobile-service-card bg-white p-h-5 text-center p-v-20 brd-16" fxFlex
               fxLayout="column" fxLayoutAlign="center center"
               routerLink="/house/register">
              <lord-icon
                colors="primary:#ffffff,secondary:#0b57d0,tertiary:#ffd244"
                src="https://cdn.lordicon.com/qbzakszx.json"
                style="width:65px;height:65px"
                trigger="hover">
              </lord-icon>

              <div class="main-mobile-service-title f-w-750 p-b-5 p-t-7">
                등기변경 알림 신청
              </div>
              <div class="text-12 f-w-650">
                등기 알림 &middot; 등본 열람
              </div>
            </a>

            <a class="main-mobile-service-card bg-white p-h-5 text-center p-v-20 brd-16" fxFlex routerLink="/analysis">
              <div>
                <lord-icon
                  colors="primary:#78adff,secondary:#0b57d0,tertiary:#BBD6FF"
                  src="https://cdn.lordicon.com/qkcczdgu.json"
                  style="width:65px;height:65px"
                  delay="2000"
                  trigger="in">
                </lord-icon>

              </div>
              <div>
                <div class="main-mobile-service-title p-t-7 f-w-750 p-b-5">
                  권리분석 시작
                </div>
                <div class="text-12 f-w-650">
                  배당 &middot; 등본 분석 &middot; 시세조회
                </div>
              </div>
            </a>
          </div>
        </div>

        <div fxFlex="100" fxHide.gt-xs fxShow>
          <div class="main-mobile-scorer-banner m-b-20" fxLayout="column">
            <a class="box-content" routerLink="/scorer">
              <div class="main-mobile-scorer-banner__inner" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                  <div class="m-b-8">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                      <div class="main-mobile-scorer-banner__title p-r-5">
                        AI 부동산 예측 시세 검색
                      </div>
                      <div>
                        <span class="accent-bg-chip-xs bg-accent-light2">베타</span>
                      </div>
                    </div>
                  </div>
                  <div class="main-mobile-scorer-banner__description">
                    <span class="f-w-700">실거래가 &middot; AI 예측 &middot; 시세 비교 분석</span>
                  </div>
                </div>
                <div fxHide.gt-xs fxShow>
                  <lord-icon
                    colors="primary:#bbd6ff,secondary:#0b57d0,tertiary:#78adff,quaternary:#ffffff"
                    src="https://cdn.lordicon.com/xowcggal.json"
                    state="hover-pinch"
                    style="width:60px;height:60px"
                    trigger="in"></lord-icon>
                </div>
              </div>

            </a>
          </div>
        </div>

        <div fxFlex="100" fxHide.gt-xs fxShow>
          <div class="m-b-20" fxLayout="column">
            <a class="box-content" routerLink="/info/api">
              <div class="p-h-20 p-v-25 bg-white brd-20" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                  <div class="m-b-8">
                    <div class="main-mobile-api-banner__title">
                      체크팀 API
                    </div>
                  </div>
                  <div class="main-mobile-api-banner__description">
                    <span class="f-w-700">등기변경 알림과 권리분석을 API로</span>
                  </div>
                </div>
                <div fxHide.gt-xs fxShow>
                  <lord-icon
                    colors="primary:#0b57d0,secondary:#0b57d0"
                    delay="5000"
                    src="https://cdn.lordicon.com/cjipkaez.json"
                    style="width:70px;height:70px"
                    trigger="in">
                  </lord-icon>
                </div>
              </div>

            </a>
          </div>
        </div>

        @if (isLogin) {
          <div fxShow fxHide.gt-xs>
            <div class="p-v-10 m-b-20 p-h-10">
              <app-swiper class="main-event-swiper" [autoplay]="false" paginationType="bullets">
                <swiper-slide>
                  <a [queryParams]="{type: 'EVENT'}" class="main-event-link main-referral-event-mobile"
                     fragment="referral-event" routerLink="/info/events">
                    <div fxLayout="row" fxLayoutAlign="center center">
                      <div fxFlex="30">
                        <img alt="추천인 이벤트 네이버페이 포인트 3,000원 쿠폰" class="w-100" src="assets/img/event/event-naver-pay-3000.png">
                      </div>
                      <div fxFlex="70">
                        <div class="f-16 f-w-750 p-b-6 p-l-10">친구 추천 네이버페이</div>
                        <div class="f-13 f-w-600 p-l-10">친구가 가입 후 무료 쿠폰 이용 시 지급</div>
                      </div>
                    </div>
                  </a>
                </swiper-slide>


                <swiper-slide>
                  <a [queryParams]="{id: '166'}" class="main-event-link" routerLink="/info/events/detail">
                    <div fxLayout="row" fxLayoutAlign="center center">
                      <div fxFlex="30" fxFlex.gt-xs="40">
                        <img alt="등기변경 발생 시 권리분석 50% 할인 쿠폰" class="w-100"
                             src="assets/img/event/coupon-circle-accent.svg">
                      </div>
                      <div fxFlex="70">
                        <div class="f-16 f-w-750 p-b-6 p-l-10">권리분석 50% 할인 쿠폰</div>
                        <div class="f-13 f-w-600 p-l-10">변경된 등기가 내 권리에 미치는 영향, 바로 확인해보세요!</div>
                      </div>
                    </div>
                  </a>
                </swiper-slide>

              </app-swiper>
            </div>
          </div>
        }

        <div fxFlex="100" fxHide.gt-xs fxShow>
          <a aria-label="부동산 계산기 서비스로 이동" class="main-mobile-calculator-banner m-b-20"
             routerLink="/real-estate-calculator">
            <div class="main-mobile-calculator-banner__content">
              <div>
                <h2>부동산 계산기</h2>
                <p>세금부터 대출·수익률까지 한 번에 계산해 보세요.</p>
              </div>
              <lord-icon
                colors="primary:#ffffff,secondary:#78adff,tertiary:#0b57d0"
                src="https://cdn.lordicon.com/koeqwfyr.json"
                state="hover-pinch"
                style="width:70px;height:70px"
                trigger="hover"
              ></lord-icon>
            </div>
          </a>
        </div>

        <div class="main-business-card" fxFlex="100" fxFlex.gt-xs="25">
          @if (isLogin) {
            <div ngClass.gt-xs="m-t-m110"></div>
          }
          <a fxLayout="column" ngClass.gt-xs="bg-gray-light p-v-30 brd-50 cursor text-center"
             ngClass.xs="bg-white p-h-20 p-t-10 p-b-20 brd-16 m-b-20" routerLink="/house/open">
            <div fxHide fxShow.gt-xs>
              <lord-icon
                colors="primary:#0b57d0,secondary:#EBEBEB,tertiary:#0b57d0"
                src="https://cdn.lordicon.com/glbvkwft.json"
                style="width:60px;height:60px"
                trigger="hover">
              </lord-icon>
            </div>
            <div fxHide.gt-xs fxShow>
              <lord-icon
                colors="primary:#0b57d0,secondary:#EBEBEB,tertiary:#0b57d0"
                src="https://cdn.lordicon.com/glbvkwft.json"
                style="width:55px;height:55px"
                trigger="hover">
              </lord-icon>
            </div>

            <div>
              <div ngClass.gt-xs="m-b-5" ngClass.xs="m-b-4">
                <div ngClass.gt-xs="text-17 f-w-700 p-t-5" ngClass.xs="text-15 f-w-750">
                  오픈부동산 알림 신청
                </div>
              </div>
              <div ngClass.gt-xs="text-13 f-w-500 p-b-3" ngClass.xs="f-w-600">
                투자부동산 담보현황 자동안내
              </div>
            </div>
          </a>
        </div>


        <!--계산기 베뉴 UI 시작-->
        <div fxFlex="100" fxFlex.gt-xs="25" fxHide>
          <div fxLayout="column" ngClass.gt-xs="bg-white p-l-30 p-r-20 p-v-40 brd-16 cursor hover-primary-light"
               ngClass.xs="bg-white p-h-20 p-v-20 brd-16 m-b-30" routerLink="/calculator">
            <div class="m-l-m5">
              <img alt="부동산계산기" src="assets/img/service/etc/ic_detail-main.svg"/>
            </div>
            <div>
              <div ngClass.gt-xs="m-b-5 p-t-15" ngClass.xs="m-b-4">
                <div ngClass.gt-xs="text-20 f-w-700" ngClass.xs="text-15 f-w-750">
                  부동산 계산기
                </div>
              </div>

              <div ngClass.gt-xs="f-w-500 p-b-3" ngClass.xs="f-w-600">
                증여세 &middot; 양도세 &middot; 보유세 등
              </div>
            </div>
          </div>
        </div>
        <!--계산기 베뉴 UI 끝-->

      </div>
    </section>

    @if (isLogin) {
      <div fxHide fxShow.gt-xs>
        <section class="main-event-section min-h-10">
          <div>
            <div fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center" fxLayout.xs="column"
                 class="bg-white p-t-40 p-b-35 p-r-50 p-l-40 brd-150 m-t-30 shadow-box-md">
              <div fxFlex fxFlex.gt-xs="40" fxHide fxShow.gt-xs>
                <app-swiper class="main-event-swiper" [autoplay]="false" paginationType="bullets">

                  <swiper-slide>
                    <a [queryParams]="{type: 'EVENT'}" class="main-event-link p-20" fragment="referral-event"
                       routerLink="/info/events">
                      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
                        <div fxFlex="30">
                          <img alt="추천인 이벤트 네이버페이 포인트 3,000원 쿠폰" class="w-90"
                               src="assets/img/event/event-naver-pay-3000.png">
                        </div>
                        <div fxFlex="70">
                          <div class="f-18 f-w-750 p-b-6">친구 추천하고 네이버페이 받으세요</div>
                          <div class="f-13 f-w-600">친구가 무료 쿠폰으로 서비스 이용 시 지급</div>
                        </div>
                      </div>
                    </a>
                  </swiper-slide>


                  <swiper-slide>
                    <a [queryParams]="{id: '166'}" class="main-event-link p-20" routerLink="/info/events/detail">
                      <div fxLayout="row" fxLayoutAlign="center center">
                        <div fxFlex="25">
                          <img alt="등기변경 발생 시 권리분석 50% 할인 쿠폰" class="w-90"
                               src="assets/img/event/coupon-circle-accent.svg">
                        </div>
                        <div fxFlex="75">
                          <div class="f-18 f-w-750 p-b-6">권리분석 50% 할인 쿠폰</div>
                          <div class="f-13 f-w-600">변경된 등기가 내 권리에 미치는 영향, 바로 확인해보세요!</div>
                        </div>
                      </div>
                    </a>
                  </swiper-slide>

                </app-swiper>

              </div>

              <div fxFlex fxFlexOffset.gt-xs="20" fxFlex.gt-xs="40" fxLayout="column" ngClass.xs="p-h-20"
                   ngClass.gt-xs="p-t-10">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.xs="space-between center"
                     class="text-center cursor p-b-10">

                  <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                     routerLink="/info/my-house">
                    <div fxHide fxShow.gt-xs class="box-circle-accent-md bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/ahxaipjb.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:30px;height:30px">
                      </lord-icon>
                    </div>
                    <div fxShow.xs fxHide.gt-xs class="box-circle-accent-xs bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/ahxaipjb.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:25px;height:25px">
                      </lord-icon>
                    </div>
                    <div ngClass.gt-xs="text-14 f-w-700 p-t-5" ngClass.xs="text-12 f-w-700 p-t-5">
                      등기변경 알림
                    </div>
                  </a>

                  <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                     routerLink="/analysis/info">
                    <div fxHide fxShow.gt-xs class="box-circle-accent-md bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/btfbysou.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:30px;height:30px">
                      </lord-icon>
                    </div>
                    <div fxShow.xs fxHide.gt-xs class="box-circle-accent-xs bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/btfbysou.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:25px;height:25px">
                      </lord-icon>
                    </div>
                    <div ngClass.gt-xs="text-14 f-w-700 p-t-5" ngClass.xs="text-12 f-w-700 p-t-5">
                      권리분석
                    </div>
                  </a>

                  <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                     routerLink="/info/scorer">
                    <div fxHide fxShow.gt-xs class="box-circle-accent-md bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/lrzdmsmx.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:30px;height:30px">
                      </lord-icon>
                    </div>
                    <div fxShow.xs fxHide.gt-xs class="box-circle-accent-xs bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/lrzdmsmx.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:25px;height:25px">
                      </lord-icon>
                    </div>
                    <div ngClass.gt-xs="text-14 f-w-700 p-t-5" ngClass.xs="text-12 f-w-700 p-t-5">
                      시세검색
                    </div>
                  </a>

                  <a class="main-shortcut-link text-center align-clean" fxFlex fxLayout="column"
                     routerLink="/info/open-house">
                    <div fxHide.xs fxShow.gt-xs class="box-circle-accent-md bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/cfkiwvcc.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:30px;height:30px">
                      </lord-icon>
                    </div>

                    <div fxShow.xs fxHide.gt-xs class="box-circle-accent-xs bg-accent">
                      <lord-icon
                        src="https://cdn.lordicon.com/cfkiwvcc.json"
                        trigger="hover"
                        colors="primary:#ffffff"
                        style="width:25px;height:25px">
                      </lord-icon>
                    </div>
                    <div ngClass.gt-xs="text-14 f-w-700 p-t-5" ngClass.xs="text-12 f-w-700 p-t-5">
                      오픈부동산
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </section>
      </div>
    }

    <section aria-labelledby="main-enterprise-inquiry-title" class="main-enterprise-inquiry">
      <header>
        <span class="main-enterprise-inquiry__badge">기업 고객 안내</span>
        <h2 id="main-enterprise-inquiry-title">기업 서비스 이용문의</h2>
        <p>등기변경알림·권리분석 도입이나 대량 이용이 필요하신가요?<br>서비스를 선택해 바로 문의하세요.</p>
      </header>

      <div aria-label="기업 서비스별 이용문의" class="main-enterprise-inquiry__links">
        <a [queryParams]="{ service: 'REGISTRY_ALERT' }" aria-label="등기변경알림 기업 이용문의"
           class="main-enterprise-inquiry__link" routerLink="/business-inquiry">
          <img alt="" aria-hidden="true" class="main-enterprise-inquiry__icon" height="72" src="assets/img/service/main/ask-01.svg" width="72">
          <div class="main-enterprise-inquiry__copy">
            <strong>등기변경알림</strong>
            <span>이용문의 바로가기</span>
          </div>
          <span aria-hidden="true" class="main-enterprise-inquiry__arrow">→</span>
        </a>

        <a [queryParams]="{ service: 'RIGHTS_ANALYSIS' }" aria-label="권리분석 기업 이용문의"
           class="main-enterprise-inquiry__link" routerLink="/business-inquiry">
          <img alt="" aria-hidden="true" class="main-enterprise-inquiry__icon" height="72" src="assets/img/service/main/ask-02.svg" width="72">
          <div class="main-enterprise-inquiry__copy">
            <strong>권리분석</strong>
            <span>이용문의 바로가기</span>
          </div>
          <span aria-hidden="true" class="main-enterprise-inquiry__arrow">→</span>
        </a>
      </div>
    </section>

    @if (notices.length > 0 || updates.length > 0) {
      <section aria-labelledby="main-news-title" class="main-news-section" fxHide fxShow.gt-xs>
        <div [class.main-news-section__grid--single]="notices.length === 0 || updates.length === 0"
             class="main-news-section__grid">
          @if (notices.length > 0) {
            <article class="main-news-board">
              <div class="main-news-board__heading">
                <h3>공지사항</h3>
                <a [queryParams]="{ type: 'NOTICE' }" routerLink="/info/notice">전체보기</a>
              </div>

              <div class="main-news-board__list">
                @for (notice of notices; track notice.id) {
                  <a [queryParams]="{ id: notice.id }" class="main-news-board__item" routerLink="/info/notice/detail">
                    <span>{{ notice.title }}</span>
                    <time [attr.datetime]="notice.writeAt">{{ notice.writeAt | date : 'yyyy.MM.dd' }}</time>
                  </a>
                }
              </div>
            </article>
          }

          @if (updates.length > 0) {
            <article class="main-news-board main-news-board--update">
              <div class="main-news-board__heading">
                <h3>업데이트</h3>
                <a [queryParams]="{ type: 'UPDATE' }" routerLink="/info/update">전체보기</a>
              </div>

              <div class="main-news-board__list">
                @for (update of updates; track update.id) {
                  <a [queryParams]="{ id: update.id }" class="main-news-board__item" routerLink="/info/update/detail">
                    <span>{{ update.title }}</span>
                    <time [attr.datetime]="update.writeAt">{{ update.writeAt | date : 'yyyy.MM.dd' }}</time>
                  </a>
                }
              </div>
            </article>
          }
        </div>
      </section>
    }

    <!--퀵 메뉴 끝-->
  </section>


  <!--오픈부동산 소개 UI 시작-->
  <div class="bg-white" fxHide fxShow.gt-xs>
    <section class="narrow-section min-h-10" fxLayout="column" fxLayout.gt-xs="row"
             fxLayoutAlign.gt-xs="space-around center" fxLayoutGap="30px" fxLayoutGap.gt-xs="40px">

      <div fxLayout.gt-xs="row" fxLayout.xs="column" ngClass.gt-xs="p-v-60 p-h-10 w-100" ngClass.xs="p-h-25">
        <div fxFlex.gt-xs="50">
          <div ngClass.gt-xs="p-t-40" ngClass.xs="p-t-10 p-b-10">
            <h2 ngClass.gt-xs="text-28 f-w-400 m-b-24" ngClass.xs="text-16 f-w-500 p-b-10">
              투자 부동산의<br/>
              <span class="f-w-700">담보정보를 무료로 확인</span>하세요!
            </h2>
            <div ngClass.gt-xs="text-15 f-w-500 lh-1-9 m-b-5" ngClass.xs="text-14 f-w-500 m-b-5">
              투자자는 <a class="open-house-inline-link f-w-750" routerLink="/house/open">알림 신청</a>만으로 담보현황을 확인할 수 있습니다.
            </div>

            <div fxHide fxLayout="row" fxLayoutGap="20px" fxShow.gt-xs ngClass.gt-xs="p-t-15"
                 ngClass.xs="p-t-15">

              <div fxLayout="row" fxLayoutGap="10px">
                <a class="open-house-link" ngClass.gt-xs="cursor text-14 f-w-650" ngClass.xs="text-13 f-w-650"
                   routerLink="/info/open-house">
                  서비스 소개
                </a>

                <a class="open-house-link open-house-link--primary" ngClass.gt-xs="cursor text-14 f-w-650"
                   ngClass.xs="text-13 f-w-650"
                   routerLink="/house/open">
                  무료 알림 신청
                </a>
              </div>
            </div>
          </div>
        </div>

        <div fxFlex.gt-xs="40" fxFlexOffset.gt-xs="5">
          <div ngClass.gt-xs="p-v-20 text-center">
            <a aria-label="오픈부동산 이용 파트너 자세히 보기" class="open-house-partners" routerLink="/info/open-house">
              <div class="cursor" fxLayout="row" fxLayoutGap="1px">
                <div fxFlex fxLayoutAlign="center center">
                  <div>
                    <img alt="파트너" ngClass.gt-xs="img-size-110" ngClass.xs="img-size-95p"
                         src="assets/img/service/main/logo-8percent.svg"/>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="center center">
                  <div>
                    <img alt="파트너" ngClass.gt-xs="img-size-110" ngClass.xs="img-size-95p"
                         src="assets/img/service/main/logo-cocktail.svg"/>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="center center">
                  <div>
                    <img alt="파트너" ngClass.gt-xs="img-size-110" ngClass.xs="img-size-95p"
                         src="assets/img/service/main/logo-zoom.svg"/>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="center center">
                  <div>
                    <img alt="파트너" ngClass.gt-xs="img-size-110" ngClass.xs="img-size-95p"
                         src="assets/img/service/main/logo-leading.svg"/>
                  </div>
                </div>
              </div>

              <div class="cursor m-t-m3" fxLayout="row" fxLayoutGap="1px">
                <div fxFlex fxLayoutAlign="center center">
                  <div>
                    <img alt="파트너" ngClass.gt-xs="img-size-110" ngClass.xs="img-size-95p"
                         src="assets/img/service/main/logo-daily.svg"/>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="center center">
                  <div>
                    <img alt="파트너" ngClass.gt-xs="img-size-110" ngClass.xs="img-size-95p"
                         src="assets/img/service/main/logo-fm.svg"/>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="center center">
                  <div>
                    <img alt="파트너" ngClass.gt-xs="img-size-110" ngClass.xs="img-size-95p"
                         src="assets/img/service/main/logo-ace.svg"/>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="center center">
                  <div></div>
                </div>
              </div>

            </a>
          </div>
        </div>

        <div class="p-v-10" fxHide.gt-xs fxShow>
          <div fxLayout="row" fxLayoutGap="10px">
            <a class="open-house-link text-13 f-w-700 p-l-5" routerLink="/info/open-house">
              서비스 소개
            </a>
            <a class="open-house-link open-house-link--primary text-13 f-w-700" routerLink="/house/open">
              오픈부동산 보기
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!--오픈부동산 소개 UI 끝-->


  <!--  앱 다운로드 배너 시작-->
  <div *ngIf="showStoreLink" ngClass.gt-xs="bg-gray-light p-v-50"
       ngClass.xs="bg-gray-light p-v-40 p-h-30">
    <section aria-labelledby="app-download-title" class="app-download narrow-section min-h-10 p-v-0">
      <div class="app-download__copy">
        <p class="app-download__eyebrow">CHECKTEAM APP</p>
        <h2 id="app-download-title">등기 변동을 놓치지 마세요</h2>
        <p>중요한 등기변경 정보를 푸시 알림으로 빠르게 확인할 수 있습니다.</p>
      </div>

      <div aria-label="체크팀 앱 다운로드" class="app-download__stores">
        <button (click)="openPlayStore()" aria-label="Google Play에서 체크팀 앱 다운로드" type="button">
          <img alt="Google Play" src="assets/img/store/down_google.svg"/>
        </button>
        <button (click)="openAppStore()" aria-label="App Store에서 체크팀 앱 다운로드" type="button">
          <img alt="App Store" src="assets/img/store/down_appstore.svg"/>
        </button>
      </div>
    </section>
  </div>
  <!--  앱 다운로드 배너 종료-->

</div>

<app-footer></app-footer>
